// Services/ExpertServiceLearner.js
import api from "Common/Client/Interceptor";

// Get all expert services for learners
export const getExpertServicesForLearners = async (params = {}) => {
  try {
    const response = await api.get("/indv/ExpertServices/Get-List", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching expert services for learners:", error);
    throw error;
  }
};

// Get details of a specific expert service
export const getExpertServiceDetails = async (expertServiceId) => {
  try {
    const response = await api.get(`/indv/ExpertServices/get-by-id/${expertServiceId}`);
    
    return response.data;
  } catch (error) {
    console.error("Error fetching expert service details:", error);
    throw error;
  }
};

// Purchase a service
export const purchaseExpertService = async (pricingId) => {
  try {
    const response = await api.post("/indv/ExpertServicePurchase/Request", {
      pricingId: pricingId
    });
    return response.data;
  } catch (error) {
    console.error("Error purchasing expert service:", error);
    throw error;
  }
};


// Get purchased expert services for the learner
export const getPurchasedExpertServices = async (params = {}) => {
  try {
    const response = await api.get("/indv/ExpertServicePurchase/Learner/Get-List", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching purchased expert services:", error);
    throw error;
  }
};